/**
 *
 * PureModeBook
 *
 */

import $ from 'jquery';
import _ from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import VueScrollTo from 'vue-scrollto';

import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
import ButtonBookAllFile from '@/components/ButtonBookAllFile.vue';
import StudentworkModal from '@/components/StudentworkModal.vue';
import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { OpenStudentworkModalMixin } from '@/mixins/Studentwork/OpenStudentworkModal';
import { getDurationString } from '../../../utils';

//import { IDENTITY_PAGE } from '@/constants/routes';

export default {
  name: 'PureModeBook',

  mixins: [ClassRestrictionMixin, OpenStudentworkModalMixin],

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Spinner,
    Player,
    ButtonBookAllFile,
    StudentworkModal,
  },

  data: () => {
    return {
      isShowPlayer: false,
      currentVideo: {},
      generating: false,
      currentReadingId: '',
      currentFileIdx: -1,
      promiseFetchBook: null,

      hideCurrentBtn: false,
    };
  },

  computed: {
    ...mapState({
      ms_isSetGotoLastStudy: 'isSetGotoLastStudy',
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      userInfo: 'userInfo',
    }),

    ...mapGetters({
      Book: 'PureModeBook/Book',
      _Book: 'PureModeBook/_Book',
      immLoading: 'immLoading',
      isRequest: 'PureModeBook/isRequest',
      ReadyToPlayVideos: 'PureModeBook/ReadyToPlayVideos',
      lastTimeReadingBulletId: 'PureModeBook/lastTimeReadingBulletId',
      isLockedByStudentWorkStatus: 'PureModeBook/isLockedByStudentWorkStatus',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    ///
    c_courseId() {
      return Number(this.CourseId);
    },

    BookId: function () {
      return this.$route.params.bookId;
    },

    ReadingId: function () {
      return this.$route.params.readingId ? this.$route.params.readingId : '';
    },

    //c_isNoAuth() {
    //  return Boolean(this.userInfo.authenticated === -1) && Boolean(this.userInfo.hasPay);
    //},

    c_isCpaCourse: function () {
      if (this.Book) {
        return 'cpa' === this.Book.mallCategory;
      }
    },

    ///
    c_restrictStudent() {
      if (this.Book) {
        return this.Book.restrictStudent;
      } else {
        return false;
      }
    },
  },

  created() {
    this.generatePDF = this.checkClassRestrictionAndDoFunc(this.generatePDF);
    this.promiseFetchBook = this.fetchBook();

    this.openPlayer = this.checkStudentWorkStatusAndDoFunc(this.openPlayer);
    this.openDownloadPanel = this.checkStudentWorkStatusAndDoFunc(this.openDownloadPanel);
  },

  mounted() {
    window.scrollTo(0, 0);
    this._pureModeBookMounted();
  },

  beforeDestroy() {
    $('#exam-outline-updates').modal('hide');
  },

  methods: {
    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    ...mapActions({
      getBook: 'PureModeBook/getBook',
      addToFavoriteList: 'PureModeBook/addToFavoriteList',
      generateFile: 'PureModeBook/generateFile',
    }),

    async fetchBook() {
      await this.getBook(this.BookId);
      if (this.ReadingId) {
        VueScrollTo.scrollTo(`#reading-id-${this.ReadingId}`, 1000, {
          container: '.webapp-layout-main',
          easing: 'linear',
          offset: -150,
        });
      }
    },

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find((v) => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    goToNextVideo() {
      const index = _.findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    goBack() {
      this.$router.go(-1);
    },

    async generatePDF(file, idx) {
      this.generating = true;
      this.currentFileIdx = idx;
      await this.generateFile({
        courseId: this.CourseId,
        bookId: this.BookId,
        fileId: file.fileId,
      });
      this.generating = false;
      this.currentFileIdx = -1;
    },

    async markVideo(payload) {
      await this.addToFavoriteList(payload);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.currentVideo.collected ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    changeBulletStatus(video, status) {
      this.$store.commit('PureModeBook/SET_BULLET_STATUS', { video, status });
    },

    getDurationStringText(second) {
      return getDurationString(second);
    },

    go2Mall() {
      this.$router.push(`/mall/${this.Book.cssClassName.replace('-', '')}`);
    },

    checkOutlineUpdates() {
      $('#exam-outline-updates').modal('show');
    },

    checkUpdatedBullet(readingId) {
      $('#exam-outline-updates').modal('hide');
      if (readingId) {
        VueScrollTo.scrollTo(`#reading-id-${readingId}`, 1000, {
          container: '.webapp-layout-main',
          easing: 'linear',
          offset: -150,
        });
      }
    },

    openDownloadPanel() {
      $('#CourseFile').modal('show');
    },

    scrollToReading(readingId) {
      const context = this;
      setTimeout(() => {
        context.currentReadingId = readingId;
        setTimeout(() => {
          context.currentReadingId = '';
        }, 1000);
      }, 600);

      VueScrollTo.scrollTo(`#reading-id-${readingId}`, 500, {
        container: '.webapp-layout-main',
        easing: 'linear',
        offset: -150,
      });
    },

    openLastTimeBullet() {
      if (
        -1 !== this.lastTimeReadingBulletId.readingId &&
        -1 !== this.lastTimeReadingBulletId.bulletId
      ) {
        this.$nextTick(() => {
          const btnOpenPlayer = _.find(
            this.$refs.btnsOpenPlayer,
            (btnOpenPlayer) =>
              `bullet-${this.lastTimeReadingBulletId.bulletId}` === btnOpenPlayer.id
          );
          if (btnOpenPlayer) {
            btnOpenPlayer.click();
          }
        });
      }
    },

    gotoLastTimeReading() {
      this.hideCurrentBtn = true;
      this.scrollToReading(this.lastTimeReadingBulletId.readingId);
      setTimeout(() => {
        this.openLastTimeBullet();
      }, 500);
    },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseFetchBook;
    },

    ///
    noAccessInfo() {
      if (this.isLockedByStudentWorkStatus) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `温馨提示`,
          text: '亲爱的学员，请先完成全部前置章节的作业提交以解锁当前章节～',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    checkStudentWorkStatusAndDoFunc(func) {
      return async (...args) => {
        if (this.isLockedByStudentWorkStatus) {
          this.noAccessInfo();
        } else {
          func(...args);
        }
      };
    },

    async _pureModeBookMounted() {
      await this.promiseFetchBook;
      await this.$nextTick();
      $('[data-toggle="popover"]').popover();
      setTimeout(() => {
        this.hideCurrentBtn = true;
      }, 15000);
      if (this.ms_isSetGotoLastStudy) {
        this.mm_SET_GOTO_LAST_STUDY(false);
        this.hideCurrentBtn = true;
        if (!this.$route.params.readingId && -1 !== this.lastTimeReadingBulletId.readingId) {
          this.scrollToReading(this.lastTimeReadingBulletId.readingId);
        }
        setTimeout(() => {
          this.openLastTimeBullet();
        }, 500);
      }
      //if (!this.Book.freeMode && this.c_isNoAuth) {
      //  Swal.fire({
      //    icon: 'info',
      //    title: '您还没有认证',
      //    text: '亲爱的学员请先完成认证',
      //    confirmButtonColor: '#3085d6',
      //    confirmButtonText: '去认证',
      //    allowOutsideClick: false,
      //  }).then((result) => {
      //    if (result.value) {
      //      this.$router.push(IDENTITY_PAGE)
      //    }
      //  });
      //  return
      //}
    },
  },
};
